exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-trend-inner[data-v-df729df2]{width:100%;height:100%;min-height:220px;position:relative}.trend-chart[data-v-df729df2]{position:absolute;left:0;top:0;right:0;bottom:0;width:100%;height:100%}", ""]);

// exports
